import dayjs from 'dayjs'

export default {
  localDateToUTC (date) {
    // make sure that it uses the local timezone
    const localDate = dayjs(date).local().format('YYYY-MM-DD HH:mm:ss')
    // The return the value in utc timezone
    return dayjs(localDate).utc()
  }
}
